#import "./HifoFields.graphql"

query GetHifo($id: ID!) {
  hifo(id: $id) {
    ...HifoFields
  }
}
